module.exports = __webpack_public_path__ + "img/3-6.79cc3b37.jpg";